import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'pd-install-on-ios-instructions',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Install this webapp on your iPhone</h2>

    <div mat-dialog-content>
      <ul>
        <li>
          Tap
          <img
            class="install-img"
            src="/assets/misc/installPopup.png"
            alt="browser settings button"
          />
        </li>

        <li>Tap "Add to homescreen" and confirm</li>
      </ul>
    </div>

    <div mat-dialog-actions class="justify-center sm:justify-end">
      <button
        mat-raised-button
        type="button"
        color="accent"
        (click)="dialogRef.close()"
      >
        Dismiss
      </button>
    </div>
  `,
  styles: [
    `
      .install-img {
        width: 25px;
        vertical-align: middle;
        display: inline-block;
        margin-left: 0.5rem;
      }

      ul {
        list-style: disc;
        margin: 1.5rem;
      }

      li {
        line-height: 28px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallOnIosInstructionsComponent {
  dialogRef = inject(MatDialogRef);
}
